import * as turf from '@turf/turf';

// TODO: move this to a meraki library (it also exists in tiles)
export class GISDiffer {
    /**
   * Get the diff, and if it throws with an error that looks like a float rounding issue, then try again after scaling
   */
    private getDiffWithSingleRetry = ({ clipPolygonFrom, clipPolygon }: { clipPolygonFrom: any, clipPolygon: any }) => {
        try {
            return turf.difference(clipPolygonFrom, clipPolygon);
        } catch (err) {
            if ((err as Error).message === 'Maximum call stack size exceeded') {
                // this was likely due to float rounding issues
                // so scale the polygon points to no longer be demimal
                // do the diff, then scale them back
                const scaledClipPolygonFrom = JSON.parse(JSON.stringify(clipPolygonFrom));
                const scaledClipPolygon = JSON.parse(JSON.stringify(clipPolygon));
                turf.coordEach(scaledClipPolygonFrom, (coords) => {
                    coords[0] = Math.round(Math.pow(10, 6) * coords[0]);
                    coords[1] = Math.round(Math.pow(10, 6) * coords[1]);
                });
                turf.coordEach(scaledClipPolygon, (coords) => {
                    coords[0] = Math.round(Math.pow(10, 6) * coords[0]);
                    coords[1] = Math.round(Math.pow(10, 6) * coords[1]);
                });
                const scaledDiff = turf.difference(scaledClipPolygonFrom, scaledClipPolygon);
                if (scaledDiff) {
                    turf.coordEach(scaledDiff, (coords) => {
                        coords[0] = coords[0] / Math.pow(10, 6);
                        coords[1] = coords[1] / Math.pow(10, 6);
                    });

                    const diff = scaledDiff; // rename so consuming code reads more accurately (we just unscaled it)
                    return diff;


                }
                return undefined;
            } else {
                throw err;
            }
        }
    }

    /**
     * Diff could see the result of truncate / rounding, returning a diff when there isn't any
     * so filter out that noise, only returning signficant diff.
     */
    private removeDiffNoise = (diff: any) => {
        if (diff.geometry.type === 'MultiPolygon') {
            diff.geometry.coordinates = diff.geometry.coordinates.filter((polygonCoords: any) => {
                // NOTE: would love to detect the shape.... eg 100sq meters that is only .5 meters wide... is noise
                return turf.area({
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'Polygon',
                        coordinates: polygonCoords
                    }
                } as any) >= 10;
            });

            // we may have just filtered out all the polygons b/c they were all small
            if (diff.geometry.coordinates.length === 0) {
                return undefined;
            }
        }

        // NOTE: we may want to also filter out a single small polygon... but part of the symptom
        // is a MultiPolgon with lots of very small polygons
        return diff;
    }

    /**
     * Finds the difference between two polygons by clipping the clipPolygon from the clipPolygonFrom.
     */
    public diff = ({ clipPolygonFrom, clipPolygon }: { clipPolygonFrom: any, clipPolygon: any }) => {
        if (!clipPolygonFrom) {
            throw new Error('clipPolygonFrom is required');
        }
        if (!clipPolygon) {
            // then clipPolygonFrom with clipPolygon clipped out, is clipPolygonFrom
            return clipPolygonFrom;
        }

        let result = this.getDiffWithSingleRetry({ clipPolygonFrom, clipPolygon });
        if (result) {
            result = this.removeDiffNoise(result);
        }
        return result;
    }
}
